import { Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, Spinner, } from '@chakra-ui/react';
import React from 'react';
import ScoringContent from './ScoringContent';
import { localise } from '../../../services/lang/lang';
import SuspenseWrapper from '../SuspenseWrapper/SuspenseWrapper';
import { useInspectionDetailContext } from '../../pages/upgrade/InspectionDetail/InspectionDetailProvider';
import ScoringShareContent from './Sharing/ScoringShareContent';
const ScoringWrapper = ({ inspection, onClose, isOpen, onHazardsTableMutated, }) => {
    const { isShare } = useInspectionDetailContext();
    const ScoringContentComponent = isShare
        ? ScoringShareContent
        : ScoringContent;
    return (React.createElement(Drawer, { variant: "clickable-overlay", closeOnOverlayClick: false, isOpen: isOpen, placement: "right", blockScrollOnMount: false, onClose: onClose, size: "md" },
        React.createElement(DrawerContent, null,
            React.createElement(DrawerCloseButton, null),
            React.createElement(DrawerHeader, { "data-testid": "scoring_wrapper__drawer_header" }, localise('HHSRS_SCORING')),
            React.createElement(DrawerBody, null,
                React.createElement(SuspenseWrapper, { fallback: React.createElement(Spinner, { "data-testid": "loading_spinner", m: 2 }) },
                    React.createElement(ScoringContentComponent, { handleCloseDrawer: onClose, onHazardsTableMutated: onHazardsTableMutated, inspection: inspection }))))));
};
export default ScoringWrapper;
